export default __webpack_public_path__ + "static/media/cp_geo_pk.c6b49a9f.svg";